import { InboundWebhookConnectionNodeData } from "src/constants/NodeDataTypes";

export const extractWebhookConnectionFields = (
  data: InboundWebhookConnectionNodeData,
) => {
  return [
    {
      id: data.correlation_id.id,
      value: `data.${data.correlation_id.expression}`,
    },
    {
      id: data.response.id,
      value: `data.${data.response.mapped_to}`,
    },
  ];
};
